import { atom } from "recoil";

export const defaultUserProfile = {
  user: { email: "admin@gmail.com" },
  isAuthenticated: false,
  isInitialize: false,
};

export const userProfile = atom({
  key: "userProfile",
  default: defaultUserProfile,
});

export const userToken = atom({
  key: "userToken",
  default: undefined,
});

export const default2FAProps = {
  title: "",
  visible: false,
  onClose: undefined,
  onOK: undefined,
};

export const defaultWarningProps = {
  title: "",
  visible: false,
  onClose: undefined,
  onOK: undefined,
  options: {
    showInputReason: false,
  },
};

export const defaultGenerateReportProps = {
  visible: false,
};

export const form2FAProps = atom({
  key: "form2FAProps",
  default: default2FAProps,
});

export const warningProps = atom({
  key: "warningProps",
  default: defaultWarningProps,
});

export const generateReportProps = atom({
  key: "generateReportProps",
  default: defaultGenerateReportProps,
});

export const currentTabDashboard = atom({
  key: "currentTabDashboard",
  default: undefined,
});

export const connection = atom({
  key: "connection",
  default: true,
});
